export default __webpack_public_path__ + "static/media/IMG-20241005-WA0002.b8fa78fa.jpg";